import React, { useState, useEffect } from 'react';
import { Button, Modal, Typography, Image as AntImage } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import AnimatedSection from './AnimatedSection';

const CharacterProfile = ({ character, reverse = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalWidth, setModalWidth] = useState('90vw'); // Default for smaller screens

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setModalWidth('70vw'); // Large desktops
      } else if (window.innerWidth > 992) {
        setModalWidth('80vw'); // Medium desktops
      } else if (window.innerWidth > 768) {
        setModalWidth('90vw'); // Tablets
      } else {
        setModalWidth('95vw'); // Small mobile
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call on initial mount

    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const showModal = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  const fullDesc = character.fullDescription || character.description || "No description available.";

  return (
    <AnimatedSection className={`char-profile-item ${reverse ? 'char-profile-reverse' : ''}`}>
      <div className="container char-profile-grid">
        <div className="char-profile-text">
          <h3 className="font-serif">
            {character.name}
          </h3>
          <div>
            <Button
               className='ant-btn-default char-profile-button'
               icon={<InfoCircleOutlined />}
               onClick={showModal}
            >
              View Info
            </Button>
          </div>
        </div>

        <div className="char-profile-image-container">
          <div className="char-profile-image-wrapper">
            <AntImage
              src={character.image}
              alt={character.name}
              preview={false}
            />
          </div>
        </div>
      </div>

      <Modal
        open={isModalOpen}
        onCancel={handleClose}
        footer={null} // Footer removed by setting to null
        wrapClassName="military-modal"
        width={modalWidth}
        centered
        closable={false} // Custom close button handled in header
        destroyOnClose
      >
        <div className="ant-modal-header">
             <div className="ant-modal-title">
                 CLASSIFIED: {character.name.toUpperCase()}
             </div>
             <button onClick={handleClose} className="ant-modal-close">
                 <span className="ant-modal-close-x"><span role="img" aria-label="close" className="anticon anticon-close"><svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path></svg></span></span>
             </button>
        </div>
         <div className="ant-modal-body military-modal-body-grid">
            <div className="military-modal-image-section">
                <div className="military-modal-image-container">
                    <AntImage src={character.image} alt={character.name} preview={false} />
                    <div className="military-modal-image-label id">
                        ID: {String(character.id || 'N/A').padStart(4, "0")}
                    </div>
                    <div className="military-modal-image-label status">
                        STATUS: ACTIVE
                    </div>
                </div>
            </div>
            <div className="military-modal-text-section">
                <div className="military-modal-file-box">
                    <div className="military-modal-file-header">
                        <div className="military-modal-file-indicator"></div>
                        <span className="military-modal-file-label">PERSONNEL FILE</span>
                        {character.stampLogo && (
                            <AntImage
                                src={character.stampLogo}
                                alt={`${character.name} Stamp`}
                                preview={false}
                                className="military-modal-stamp-logo-header" 
                            />
                        )}
                    </div>
                    <div className="military-modal-description-container military-scrollbar">
                      <p className="military-modal-description-text">{fullDesc}</p>
                    </div>
                </div>
            </div>
         </div>
        <div className="ant-modal-footer military-modal-footer-content">
            <div className="military-modal-footer-text">SECURITY LEVEL: TOP SECRET</div>
            {/* "Close File" Button Removed */}
        </div>
      </Modal>
    </AnimatedSection>
  );
};

export default CharacterProfile;